import React, { FC } from "react";
import imgTalkSigText from "../../assets/talksig-text.png";
import { ImgTalkSigWheel, ImgTalkSigText, Container } from "./styles";
import imgTalkSigWheel from "../../assets/talksig-wheel.png";
import { Variants } from "framer-motion";

interface Props {
  height?: string;
  isStatic?: boolean;
}

const TalkSigWheel: FC<Props> = ({ height, isStatic }: Props): JSX.Element => {
  const spin: Variants = {
    hidden: {
      opacity: 0,
      scale: 0,
    },
    visible: {
      opacity: 1,
      scale: 1,
    },
  };

  return (
    <Container
      variants={spin}
      initial={isStatic ? "visible" : "hidden"}
      animate={"visible"}
      transition={{ duration: 1 }}
      height={height ?? "55vh"}
    >
      <ImgTalkSigWheel
        animate={isStatic ? undefined : { rotate: 360 }}
        transition={{ duration: 2.5, delay: 1 }}
        src={imgTalkSigWheel}
      />
      <ImgTalkSigText src={imgTalkSigText} alt={"Talking Significance"} />
    </Container>
  );
};

export default TalkSigWheel;
